import { css } from "lit";
import { constants as coreConstants } from "@omegagrid/core";
import constants from "../../constants";

export const itemStyle = css`
	.item {
		padding-bottom: ${constants.FILTER_PADDING / 2}px;
	}

	.item {
		padding-top: ${constants.FILTER_PADDING / 2}px;
	}

	.item:first-child {
		padding-top: 0;
	}

	.item-inner {
		border: 1px solid var(--og-colortype-accent-border-color);
		background-color: var(--og-accent-color-alpha-30);
		border-radius: var(--og-base-radius);
	}

	.item, .item-indicator {
		min-height: ${coreConstants.LIST_ITEM_HEIGHT}px;
	}

	.item-indicator { 
		padding-left: 5px;
		color: var(--og-text-color-3);
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.item-indicator > * {
		flex: 1;
	}

	.item-indicator > og-button, .item-indicator > og-dropdown {
		flex: 0;
		min-width: 20px;
	}

	.item-indicator-name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	rp-fsection-indicators-filters {
		margin-left: ${constants.FILTER_PADDING / 2}px;
	}

	rp-fsection-indicators-formula {
		margin: ${constants.FILTER_PADDING / 2}px;
		margin-top: 0;
	}
`;

export const style = css`
	og-dropdown-menu, og-button.add {
		width: 100%;
		border: 1px dashed var(--og-accent-color);
	}
`
